"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDynamicValues = exports.validateJsonData = void 0;
const Ajv = require("ajv");
const schema_1 = require("./schema");
const types_1 = require("./types");
const jsonSchemaValidator = new Ajv();
exports.validateJsonData = (data) => {
    const validate = jsonSchemaValidator.compile(schema_1.default);
    const valid = validate(data);
    if (!valid && validate.errors != null) {
        return validate.errors;
    }
    return [];
};
const ENV_PREFIX = 'env.';
const CONTEXT_PREFIX = 'context.';
function isValueNode(node) {
    return node.nodeType === types_1.NodeType.Value;
}
function validateMetaNode(rootNode) {
    const rootValueNodeType = rootNode.default.returnType;
    const children = rootNode.children;
    for (const [index, child] of children.entries()) {
        const childPath = `.children[${index}]`;
        const childValidationResult = validateInternalNode(child, rootValueNodeType, childPath);
        if (childValidationResult !== null) {
            return childValidationResult;
        }
    }
    return null;
}
function validateInternalNode(internalNode, rootValueNodeType, path) {
    if (internalNode.nodeType === types_1.NodeType.Value) {
        if (internalNode.returnType !== rootValueNodeType) {
            return {
                keyword: 'Value node return type',
                dataPath: path,
                message: `Invalid value node return type: found ${internalNode.returnType} when root node has type ${rootValueNodeType}`,
            };
        }
        return null;
    }
    // A RuleNode cannot be a leaf node.
    if (internalNode.children.length === 0) {
        return {
            keyword: 'Rule node empty childen',
            dataPath: path,
            message: 'Rule node must have children',
        };
    }
    // The node target has to match the env or context prefix.
    if (internalNode.nodeType === types_1.NodeType.Blacklist ||
        internalNode.nodeType === types_1.NodeType.Whitelist ||
        internalNode.nodeType === types_1.NodeType.Allowlist ||
        internalNode.nodeType === types_1.NodeType.Denylist) {
        if (!(internalNode.target.startsWith(ENV_PREFIX) ||
            internalNode.target.startsWith(CONTEXT_PREFIX))) {
            return {
                keyword: 'Allowlist / Denylist node target',
                dataPath: path,
                message: `Invalid allowlist / denylist target found ${internalNode.target}`,
            };
        }
    }
    if (internalNode.nodeType === types_1.NodeType.Multivariate) {
        if (internalNode.buckets.length !== internalNode.children.length) {
            return {
                keyword: 'Multivariate bucket config',
                dataPath: path,
                message: `Invalid multivariate bucket config found. Buckets length: ${internalNode.buckets.length}, Children length: ${internalNode.children.length}`,
            };
        }
        if (internalNode.buckets.reduce((acc, curr) => acc + curr, 0) !== 100) {
            return {
                keyword: 'Multivariate bucket config',
                dataPath: path,
                message: `Invalid multivariate bucket config found. Bucket values: ${internalNode.buckets} do not sum to 100%`,
            };
        }
    }
    const children = internalNode.children;
    // Make sure a ValueNode does not have any siblings,
    // Except for Multivariate nodes
    if (children.length > 1 && internalNode.nodeType !== types_1.NodeType.Multivariate) {
        if (children.some(isValueNode)) {
            return {
                keyword: 'Value node has siblings',
                dataPath: `${path}.children[]`,
                message: 'A value node cannot have siblings',
            };
        }
    }
    for (const [index, child] of children.entries()) {
        const childPath = `${path}.children[${index}]`;
        const childValidationResult = validateInternalNode(child, rootValueNodeType, childPath);
        if (childValidationResult !== null) {
            return childValidationResult;
        }
    }
    return null;
}
// Assuming that object matches the type, we only need to check two things
// 	1. Value node's return type matches the MetaNode's return type.
//  2. All rule nodes have children. This also ensures that value nodes are
//     leaf nodes.
// Function that takes a root metanode and validates all children nodes.
function validateDynamicValues(rootNode) {
    const errors = exports.validateJsonData(rootNode);
    if (errors.length > 0) {
        return errors;
    }
    const nodeValidationResult = validateMetaNode(rootNode);
    if (nodeValidationResult == null) {
        return [];
    }
    return [nodeValidationResult];
}
exports.validateDynamicValues = validateDynamicValues;
//# sourceMappingURL=validation.js.map